import styled, { css } from 'styled-components';

import { basicSmallTextStyle, Button, IconWrapper, StyledFlex, Text } from '@dreryk/react-components';

type DismissibleStyledProps = {
   $dismissed?: boolean;
};

export const StyledEmergencyNotificationAlertItem = styled(StyledFlex)<DismissibleStyledProps>`
   ${({ theme, $dismissed }) => css`
      background: ${$dismissed ? theme.backgroundLighter : theme.errorLighter};
      fill: ${$dismissed ? theme.background : theme.error};
   `};

   align-items: center;
   justify-content: space-between;
   gap: 24px;
   padding: 10px 12px 12px 10px;
   border-radius: 16px;
   width: 100%;
`;

StyledEmergencyNotificationAlertItem.displayName = 'StyledEmergencyNotificationAlertItem';

export const StyledEmergencyNotificationAlertItemIcon = styled(IconWrapper)`
   align-self: baseline;
   margin-top: -3px; ;
`;

StyledEmergencyNotificationAlertItemIcon.displayName = 'StyledEmergencyNotificationAlertItemIcon';

export const StyledEmergencyNotificationAlertItemButton = styled(Button)`
   flex-shrink: 0;

   ${({ theme }) => `
      background: ${theme.error};
      border-color: ${theme.error};
      &:not(:disabled):hover {
         background: ${theme.errorDark};
         border-color: ${theme.errorDark};
      }
   `}
`;

StyledEmergencyNotificationAlertItemButton.displayName = 'StyledEmergencyNotificationAlertItemButton';

export const StyledEmergencyNotificationAlertItemDismissedLabel = styled(Text)`
   flex-shrink: 0;
   white-space: nowrap;
   color: ${({ theme }) => theme.backgroundDark};
   ${basicSmallTextStyle};
`;

StyledEmergencyNotificationAlertItemDismissedLabel.displayName = 'StyledEmergencyNotificationAlertItemDismissedLabel';
